module.exports = __webpack_public_path__ + "static/img/bg.2228f628.png";